export const FETCH_EVENTS_REQUEST = 'FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'FETCH_EVENTS_FAILURE';
export const FETCH_EVENT_TEAMS_REQUEST = 'FETCH_EVENT_TEAMS_REQUEST';
export const FETCH_EVENT_TEAMS_SUCCESS = 'FETCH_EVENT_TEAMS_SUCCESS';
export const FETCH_EVENT_TEAMS_FAILURE = 'FETCH_EVENT_TEAMS_FAILURE';
export const DELETE_EVENT = 'DELETE_EVENT';
